<template>
  <v-navigation-drawer
    app
    :value="$vuetify.breakpoint.lgAndUp || appDrawerLeft"
    @input="$store.commit('setAppDrawerLeft', $vuetify.breakpoint.lgAndUp ? false : $event)"
    fixed
    flat
    width="260"
    class="ch-left-navigation"
    :style="$vuetify.breakpoint.mdAndDown ? { top: '60px', height: 'calc(100vh - 60px)' } : {}"
  >
    <div
      v-if="$vuetify.breakpoint.lgAndUp"
      class="logo-container py-3"
      :class="{ 'flex-grow-1': $vuetify.breakpoint.smAndDown }"
    >
      <a href="/">
        <img src="@/assets/logo.png" />
      </a>
    </div>
    <div class="py-4">
      <v-list
        v-if="$vuetify.breakpoint.smAndDown"
        dense
        nav
        class="py-0 mb-4 px-4"
      >
        <v-list-item
          link
          class="px-3"
          href="/"
        >
          <v-list-item-icon>
            <v-icon small>fa fa-chevron-left</v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title>Back to Shopping</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
      <v-list
        dense
        nav
        class="py-0 mb-4 px-4"
      >
        <v-list-item
          v-for="(item, $itemIndex) in $root.menuItems"
          :key="$itemIndex"
          link
          class="px-3"
          v-bind="{ href: item.meta.href, to: { name: item.name } }"
          :exact="item.meta.exact"
        >
          <v-list-item-icon>
            <v-icon>fa {{ item.meta.icon || 'fa-comment-alt' }}</v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title>{{ item.meta.name || item.name }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </div>
    <template v-slot:append>
      <v-list
        dense
        nav
        class="py-0 mb-2 px-4"
      >
        <v-list-item
          link
          class="px-3"
          @click="logout"
        >
          <v-list-item-icon>
            <v-icon>fa fa-sign-out-alt</v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title>Log Out</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </template>
  </v-navigation-drawer>
</template>

<style lang="scss">
.ch-left-navigation {
  .logo-container {
    height: 60px;
    width: 260px;
    text-align: center;
    background-color: #000;
    img {
      height: 100%;
    }
  }
  .v-navigation-drawer__border {
    background-color: $lightBorder !important;
  }
  .v-list-item__icon {
    width: 30px;
    margin-right: 24px !important;
  }
}
</style>

<script>
import { mapState, mapMutations, mapActions } from 'vuex'

export default {
  computed: {
    ...mapState(['appDrawerLeft'])
  },
  methods: {
    ...mapMutations(['setAppDrawerLeft']),
    ...mapActions(['logout'])
  }
}
</script>
